import * as tslib_1 from "tslib";
import { WebPlugin } from './index';
var SplashScreenPluginWeb = /** @class */ (function (_super) {
    tslib_1.__extends(SplashScreenPluginWeb, _super);
    function SplashScreenPluginWeb() {
        return _super.call(this, {
            name: 'SplashScreen',
            platforms: ['web']
        }) || this;
    }
    SplashScreenPluginWeb.prototype.show = function (_options, _callback) {
        return Promise.resolve();
    };
    SplashScreenPluginWeb.prototype.hide = function (_options, _callback) {
        return Promise.resolve();
    };
    return SplashScreenPluginWeb;
}(WebPlugin));
export { SplashScreenPluginWeb };
var SplashScreen = new SplashScreenPluginWeb();
export { SplashScreen };
//# sourceMappingURL=splash-screen.js.map